import { cloneDeep } from 'lodash';
import { useFlags } from 'launchdarkly-react-client-sdk';
import { useSelector } from 'react-redux';
import type { ClipAvailability } from '../../../models/channel';
import { Channel, Item, Pagination } from '../../../models';
import { enhanceFetchedAsset } from '../../../pages/assets/asset-listing/enhanceFetchedAsset';
import { ChannelFormData } from '../../../pages/channelmanager/channels/channel-editor/ChannelFormData';
import { AssetLookup } from '../../../utils/assetLookup';
import { fuelUserAccessSliceSelector } from '../../slices/fuelUserAccess';

export class ProgrammedLodContentForm {
  playlist: Array<Item> = []; // to be populated by the LOD Content tab on load to avoid too many fetch calls on initial channel load
  clipIds: string[] = [];
  clipEntries: Record<string, ClipAvailability> = {};

  static createFromData(data: ChannelFormData, permissions, flags) {
    const form = new ProgrammedLodContentForm();
    form.loadData(data, permissions, flags);
    return form;
  }

  loadData(data: ChannelFormData, permissions, flags) {
    const { channel, assets, transitionTemplate } = data;
    const assetLookup = new AssetLookup(assets);
    this.loadPlaylist(channel, assetLookup, permissions, flags);
  }

  private loadPlaylist(channel: Channel, assetLookup: AssetLookup, permissions, flags) {
    if (channel.clipIds && channel.clipIds.length > 0) {
      this.clipIds = channel.clipIds;
    }
    this.clipEntries = channel.clipEntries ?? {};
  }
}
